import { render, staticRenderFns } from "./productitemunits.vue?vue&type=template&id=331a33f2&scoped=true&"
import script from "./productitemunits.vue?vue&type=script&lang=js&"
export * from "./productitemunits.vue?vue&type=script&lang=js&"
import style0 from "./productitemunits.vue?vue&type=style&index=0&id=331a33f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a33f2",
  null
  
)

export default component.exports